import React, {useEffect, useState} from 'react';
import {useEstadisticasDsKey} from '../hooks/useEstadisticasDsKey';
import {DataLlave} from '../../bussines/entities/EstadisticasLlave.entity';
import { CopyInfo } from '../components/CopyInfo';
import { InfoDialog } from '../components/InfoDialog';

const columns = [
   {
      name: 'ruc',
      label: 'DNI/RUC',
      options: {
         filter: true,
         display: 'true'
      }
   },
   {
      name: 'razonsocial',
      label: 'Cliente',
      options: {
         filter: true,
         display: 'true'
      }
   },
   {
      name: 'documento',
      label: 'Documento',
      options: {
         filter: true,
         display: 'true'
      }
   },
   {
      name: 'codactivacion',
      label: 'Codigo Activación',
      options: {
         filter: true,
         display: 'true',
         customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
            let time = tableMeta.rowData[3];
            if (typeof time === 'string') {
               time = parseFloat(time.replace(/[^\d.-]/g, ''));
            }
            return <CopyInfo info={value} color="inherit" />;
         }
      }
   },
   {
      name: 'producto',
      label: 'Producto',
      options: {
         filter: true,
         display: 'true'
      }
   },
   {
      name: 'fechaExpiracion',
      label: 'Fecha de Expiración',
      options: {
         filter: true,
         display: 'true'
      }
   }
];

export const CardLlavesPorVencer: React.FC<{}> = () => {
   const [llavesPorExpirar, setLlavesPorExpirar] = useState<DataLlave[]>([]);
   const {getLlavesPorExpirar} = useEstadisticasDsKey();
   const fetchLlavesPorExpirar = async () => {
      const result = await getLlavesPorExpirar();
      if (result) {
         setLlavesPorExpirar(result);
      }
   };
   useEffect(() => {
      fetchLlavesPorExpirar();
   }, []);

   return (
      <InfoDialog
         descripcion="Llaves próximas a expirar en 7 dias"
         list={llavesPorExpirar}
         isCriticalValue
         columns={columns}
      />
   );
};
